import { useQuery } from "@tanstack/react-query";
import api from "@/lib/axios-interceptor";

export default function useTempQuery(
  temp: number[] = [-40, +40],
  location: "all" | "western" | "eastern" | "central" | "gobi" = "all"
) {
  const isEnabled = temp.length === 2;

  const { data, isLoading, isError } = useQuery<types.Wind[]>({
    queryKey: ["temp", temp, location],
    queryFn: async () => {
      const res = await api.get<types.Wind[]>(
        `/v1/temp/${location}?temp_min=${temp[0]}&temp_max=${temp[1]}`
      );

      return res.data;
    },
    enabled: isEnabled,
    // staleTime: 60 * 60 * 1000, // 1 цагийн cache (хүсвэл)
  });

  return {
    data,
    isLoading,
    isError,
  };
}
